import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dividers-1"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.4275 8.73669C15.4275 10.5679 13.8931 12.0525 12.0004 12.0525C10.1076 12.0525 8.57324 10.5679 8.57324 8.73669C8.57324 6.90543 10.1076 5.4209 12.0004 5.4209C13.8931 5.4209 15.4275 6.90543 15.4275 8.73669Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12.0004 5.42105C10.1076 5.42105 8.57325 6.90558 8.57325 8.73684C8.57325 10.5681 10.1076 12.0526 12.0004 12.0526C13.8931 12.0526 15.4275 10.5681 15.4275 8.73684C15.4275 6.90558 13.8931 5.42105 12.0004 5.42105ZM12.0004 5.42105V2M20.3022 16.3018C15.0428 18.6998 8.95772 18.6998 3.69824 16.3018M9.57037 11.075L4.00367 22H4.00024L9.57037 11.075ZM14.4301 11.075L19.9968 22H20.0002L14.4301 11.075Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Dividers1 = Vue.extend<IconProps>({
  name: 'Dividers1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'dividers-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Dividers1;
